import React from 'react';
import { FaTooth, FaTeeth, FaTeethOpen, FaChild } from 'react-icons/fa';
import { MdMedicalServices, MdCleaningServices } from 'react-icons/md';
import { useTranslation } from '../../context/LanguageContext';
import { ServiceCard } from './Cards';

/**
 * Service definitions — module scope so the icon JSX references stay stable
 * across renders (avoids re-creating elements every render).
 */
const SERVICES = [
    { icon: <FaTooth />, titleKey: 'servicesSection.therapy', descKey: 'servicesSection.therapyDesc' },
    { icon: <MdMedicalServices />, titleKey: 'servicesSection.surgery', descKey: 'servicesSection.surgeryDesc' },
    { icon: <FaTeeth />, titleKey: 'servicesSection.orthopedics', descKey: 'servicesSection.orthopedicsDesc' },
    { icon: <FaTeethOpen />, titleKey: 'servicesSection.orthodontics', descKey: 'servicesSection.orthodonticsDesc' },
    { icon: <MdCleaningServices />, titleKey: 'servicesSection.hygiene', descKey: 'servicesSection.hygieneDesc' },
    { icon: <FaChild />, titleKey: 'servicesSection.pediatric', descKey: 'servicesSection.pediatricDesc' },
];

/**
 * Home — Services overview grid.
 */
export const HomeServicesSection = () => {
    const { t } = useTranslation();

    return (
        <section id="service-section" className="py-14 sm:py-18 md:py-24 lg:py-28 bg-gray-50">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-10 sm:mb-14">
                    <span className="inline-block px-4 py-1.5 bg-gold/10 text-gold font-semibold text-sm rounded-full mb-4">
                        {t('servicesSection.title')}
                    </span>
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                        {t('servicesSection.title')}
                    </h2>
                    <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
                        {t('servicesSection.subtitle')}
                    </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
                    {SERVICES.map(({ icon, titleKey, descKey }) => (
                        <ServiceCard key={titleKey} icon={icon} title={t(titleKey)} description={t(descKey)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

